import { DataBean } from "../DataBean";

export class AssetDepreciationType extends DataBean {


    public async getFixedAssetDepreciationTypeConstants(id:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getFixedAssetDepreciationTypeConstants_Number", [id]);
    }
}